import styled, { css } from 'styled-components';
import { Button } from '../Button/Button';
import { transitionFunc } from '../theme/utils';
import { textTinyNormal, textTinySemiBold } from '../DesignSystem/Typography';
import { HudIcon } from '../Icons/HudIcons';

const iconStyle = css`
  svg path {
    stroke: var(--text-standard-primary-subtle);
  }
`;

export const PromptContainer = styled.div<{ expanded: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: ${({ expanded }) => (expanded ? '300px' : '160px')};
  padding: var(--space-150);
  color: var(--text-standard-secondary);
  background-color: var(--text-standard-primary-subtle);
  border-radius: 8px;
`;

export const Prompt = styled.div<{ expanded: boolean }>`
  ${textTinyNormal};
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  overflow: ${({ expanded }) => (expanded ? 'auto' : 'hidden')};
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.1) transparent;

  ${({ expanded }) =>
    !expanded &&
    `
      background: linear-gradient(180deg, var(--text-standard-secondary) 30%, var(--text-standard-primary-subtle) 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    `}
`;

export const ToggleButton = styled(Button)`
  ${textTinySemiBold};
  color: var(--text-subtle);
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  padding: var(--space-100);
  padding-bottom: 0;
  border-top: 1px solid #434547;
  margin-top: var(--space-150);
`;

export const ShowIcon = styled(HudIcon)<{ expanded: boolean }>`
  display: flex;
  align-items: center;
  color: var(--text-subtle);

  transform: rotate(${({ expanded }) => (expanded ? '0deg' : '180deg')});
  transition: transform 0.25s ${transitionFunc};
`;

export const CopyPromptButton = styled(Button)`
  width: 180px;
  height: 36px;
  justify-content: center;

  ${iconStyle}
`;
